import Sortable from "sortablejs";
export function draggable(node, options) {
    new Sortable(node, options);
}
